import { Text } from "@react-pdf/renderer";
import React, { ReactElement } from "react";
import {
  blockquote,
  li,
  ul,
  ol,
  paragraph,
  h1,
  h2,
  h3,
  h4,
  h5,
  strong,
  img,
  link,
  table,
  thead,
  tbody,
  tr,
  td,
  th,
  em,
  span,
  pre
} from "./handlersTags";

export const parserTags = ({ type, props }: ReactElement) => {
  switch (type) {
    case 'h1':
      return h1(props.children)
    case 'h2':
      return h2(props.children)
    case 'h3':
      return h3(props.children)
    case 'h4':
      return h4(props.children)
    case 'h5':
      return h5(props.children)
    case 'p':
      return paragraph(props.children)
    case 'li':
      return li(props.children)
    case 'ul':
      return ul(props.children)
    case 'em':
      return em(props.children)
    case 'span':
      return span(props.children)
    case 'a':
      return link(props.children)
    case 'ol':
      return ol(props)
    case 'blockquote':
      return blockquote(props.children)
    case 'strong':
      return strong(props.children)
    case 'img':
      return img(props.src)
    case 'table':
      return table(props.children)
    case 'thead':
      return thead(props.children)
    case 'tbody':
      return tbody(props.children)
    case 'tr':
      return tr(props.children)
    case 'td':
      return td(props.children)
    case 'th':
      return th(props.children)
    case 'pre':
      return pre(props.children)
    default:
      return (<Text>{props.children}</Text>)
  }
}